import { LOGOUT } from '../../../store/Types';

export const ALL_ENTIDADES = 'ALL_ENTIDADES';
export const ACTIVO_ENTIDADES = 'ACTIVO_ENTIDADES';
export const LOADING_ALL_ENTIDADES = 'LOADING_ALL_ENTIDADES';
export const PARAMS_ENTIDADES = 'PARAMS_ENTIDADES';
export const AJUSTES_ENTIDADES = 'AJUSTES_ENTIDADES';
export const SETTINGS_ENTIDADES = 'SETTINGS_ENTIDADES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
  ajustes: null,
  settings: {
    isBanda: false,
  },
};

export const entidadesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENTIDADES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_ENTIDADES:
      return {
        ...state,
        activo: action.payload,
      };
    case SETTINGS_ENTIDADES:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload,
        },
      };
    case LOADING_ALL_ENTIDADES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ENTIDADES:
      return {
        ...state,
        params: action.payload,
      };
    case AJUSTES_ENTIDADES:
      return {
        ...state,
        ajustes: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
